var StatusCode;
(function (StatusCode) {
    StatusCode["OK"] = "200";
    StatusCode["Created"] = "201";
    StatusCode["NoContent"] = "204";
    StatusCode["BadRequest"] = "400";
    StatusCode["Unauthorized"] = "401";
    StatusCode["Forbidden"] = "403";
    StatusCode["NotFound"] = "404";
    StatusCode["InternalServerError"] = "500";
    StatusCode["NotImplemented"] = "501";
})(StatusCode || (StatusCode = {}));
(function (StatusCode) {
    function IsSuccess(code) {
        return (code === StatusCode.OK ||
            code === StatusCode.Created ||
            code === StatusCode.NoContent);
    }
    StatusCode.IsSuccess = IsSuccess;
})(StatusCode || (StatusCode = {}));
export { StatusCode };
